<div class="title-center mt-5">
  <img src="./assets/media/icons/png/Cryixcropped.png" alt="My Image">
  <br>
  <br>
  <h2>Service Request</h2>
</div>

<div class="title-center mt-5 container">
      <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs justify-content-center" (navChange)="tabChange($event)">
        <li [ngbNavItem]="1">
          <!-- <a ngbNavLink>Private</a> -->
          <ng-template ngbNavContent >
            <div class="modal-body"  >
              <div class="container">
              <div class="row formparentRow">
                <div class="col-lg-4 text-end">
                  <label class="control-label centeredlabel">Mobile Number  <label class="errorcolor">*&nbsp;&nbsp;</label></label>
                </div>
                <div class="col-lg-4">
                  <input class="form-control" type="text" (keypress)="numberOnly($event)" placeholder="Enter mobile number"
                  onKeyPress="if(this.value.length==10) return false;" [(ngModel)]="mobile_no" pattern="^[6-9]\d{9}$" maxlength="10"
                   (input)="getnumber()" (change)="onchangecusno()">
                </div>
                <br>
                <div class="col-lg-2 bt-mr">
                  <button class="btn btn-outline-success btn-pill btn-sm custom-btn ml-2 disabledsubmit successmsg" (click)="submitsendotp()"
                  [disabled]="!otpbutton">Send OTP</button>
                </div>
              </div>
              <div *ngIf="mobileNoError" style="color: red;">{{mobileNoError}}</div>
              <div *ngIf="customer_err" style="color: red;">{{customer_err}}</div>
              <div *ngIf ="otpdigit" class="row formparentRow justify-content-center">
                <div class="col-lg-2 text-end">
                  <label class="control-label centeredlabel">Enter 6 digit OTP&nbsp;&nbsp;</label>
                </div>
                <div class="col-lg-4 ">
                  <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="otpConfig"></ng-otp-input>
                  <!-- <div class="otp-boxes">
                    <input
                      type="text"
                      class="form-control otp-input"
                      [(ngModel)]="otpCode"
                      (input)="onOtpInputChange()"
                      maxlength="6"
                    />
                    <div class="otp-boxes">
                      <div *ngFor="let digit of otpCodeDigits; let i = index" class="otp-box" (click)="focusInput(i)">
                        {{ digit || '_' }}
                      </div>
                    </div>
                  </div> -->
                </div>
                <div class="col-lg-2 bt-mr">
                  <button
                    class="btn btn-pill btn-sm custom-btn ml-2 disabledsubmit successbtn" [disabled]="otpsubmit"
                    (click)="submit()" >Submit</button>
                </div>
               
              </div>
               <p *ngIf="user_error" style="color: red;">{{user_error}}</p>
              <div *ngIf ="otpdigit" class="row formparentRow justify-content-center">
                <div class="col-lg-6 commonfont" style="font-size: 17px; color: black;">
                  You can resend the OTP <span *ngIf="!resendbutton">after</span> <span *ngIf="!resendbutton" class="error"> {{countdownValue}}</span> <span *ngIf="!resendbutton"> seconds</span> 
                </div>
                <div class="col-lg-2">
                  <button class="btn btn-pill btn-sm custom-btn ml-2 disabledsubmit successbtn"
                  [disabled]="!resendbutton" (click)="resendotp()" >Resend</button>
                </div>
              </div>
            </div>
            </div>
          </ng-template>
        </li>
        <!-- <li [ngbNavItem]="2"> -->
          <!-- <a ngbNavLink>Government</a> -->
          <!-- <ng-template ngbNavContent> -->
            <!-- <div class="modal-body">
              <div class="container">
                <div class="row formparentRow">
                  <div class="col-lg-4 text-end">
                    <label class="control-label centeredlabel">Customer ID <label class="errorcolor">*</label></label>
                  </div>
                  <div class="col-lg-4 generalHeaderWithTitleSearch">
                    <div class="input-container generalHeaderSearch">
                      <input type="text" placeholder="{{'CUSTOMER.ENTER' | translate}} {{'RAISETCKT.CUS_CODE' | translate}}"
                        name="cus_code" class="form-control" ng-model="cus_code" [(ngModel)]="cus_code"
                        [ngModelOptions]="{standalone: true}" (change)="onchangecusid()"/>
                      <button type="submit" class="btnsearch disabledsubmit" (click)="get_site_details()" [disabled]="cus_code.trim().length == 0">{{'RAISETCKT.GO' | translate}}</button>
                    </div>
                  </div>
                </div>
                <div class="row formparentRow" *ngIf="site.length > 0">
                  <div class="col-lg-4 text-end">
                    <label class="control-label centeredlabel">Select Site <label class="errorcolor">*</label></label>
                  </div>
                  <div class="col-lg-4">
                    <select name="site_id" id="site_id" [(ngModel)]="site_id" class="form-control styled-select">
                        <option value="null" selected hidden>{{'NEW_SUBSCRIPTION.SELECT_SEL' | translate}} {{'SITE.SITE_ID' | translate}}</option>
                        <option *ngFor="let s of site" value="{{s.site_id}}">{{s.site_id}}-{{s.post_code}}-{{s.location}}</option>
                      </select>
                    <p *ngIf="otpsend_details != ''" style="margin-top: 6px !important; margin-bottom: -10px !important; margin-left: 10px;"><label class="control-label centeredlabel"> OTP has sent to this number</label>&nbsp;<label style="color: #253F68;"> {{otpsend_details.masked_number}}</label></p>
                  </div>
                  <div class="col-lg-2">
                    <button class="btn btn-outline-success btn-pill btn-sm custom-btn ml-2 disabledsubmit successmsg"
                      (click)="entersendotp()" [disabled]="site_id == null || site_id == undefined">Send OTP</button>
                  </div>
                </div>
                  <div *ngIf="otpdigit" class="row formparentRow justify-content-center">
                  <div class="col-lg-2 text-end">
                    <label class="control-label centeredlabel">Enter 6 digit OTP</label>
                  </div>
                  <div class="col-lg-4"> 
                    <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="otpConfig"></ng-otp-input>
                  </div>
                  <div class="col-lg-2">
                    <button class="btn btn-pill btn-sm custom-btn ml-2 disabledsubmit successbtn" [disabled]="otpsubmit"
                      (click)="submit()">Submit</button>
                  </div>
          
                </div>
                <p *ngIf="user_error" style="color: red;">{{user_error}}</p>
                <div *ngIf="otpdigit" class="row formparentRow justify-content-center">
                  <div class="col-lg-6 commonfont" style="font-size: 17px; color: black;">
                    You can resend the OTP after <span class="error">{{countdownValue}}</span> seconds
                  </div>
                  <div class="col-lg-2 text-center">
                    <button class="btn btn-pill btn-sm custom-btn ml-2 disabledsubmit successbtn btn btn-primary" [disabled]="!resendbutton"
                      (click)="resendotp()">Resend</button>
                  </div>
                </div>
              </div>
            </div> -->
          <!-- </ng-template> -->
        <!-- </li> -->
      </ul>
      <div [ngbNavOutlet]="nav"></div>
</div>

  <br>
<!-- begin:: Footer -->
<div class="kt-footer kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop" id="kt_footer">
  <div class="row kt-container align-items-center" [ngClass]="{'kt-container--fluid': fluid}">
    <div class="col-lg-5 kt-footer__copyright">
      <!-- <img style="height: 20px;" src="./assets/media/icons/png/FieldProLogo3.png" alt="My Image"> -->
      <a style="margin-top: 6px;" href="http://kaspontech.com" target="_blank" class="kt-link">Powered by Kaspon Techworks Pvt Ltd</a>
    </div>
    <div class="col-lg-4 kt-footer__copyright"></div>
    <div class="col-lg-3 kt-footer__copyright text-right" style="margin-top: 6px; display: flex; justify-content: flex-end;">
      <!-- &nbsp;&copy;&nbsp; {{today | date:'yyyy'}}.&nbsp;  -->
      <!-- All rights reserved by  -->
      <a href="https://www.cyrixhealthcare.com" target="_blank" class="kt-link">Cyrix Healthcare Pvt Ltd.</a>
    </div>
  </div>
</div>
<!-- end:: Footer -->